import {Site} from "../api/site.ts";

export const dashboardHome = (site: Site | string): string => {
    if (typeof site !== 'string') {
        site = site.id
    }
    return `/u/dashboard/site/${site}`;
}